/**
 * General checkbox normalizer for mobile browsers
 * Converts "on"/"off" to proper booleans recursively
 */
export const normalizeCheckboxValues = (data) =>
  Object.fromEntries(
    Object.entries(data || {}).map(([k, v]) => [
      k,
      typeof v === 'object' && v !== null
        ? normalizeCheckboxValues(v)
        : v === 'on'
        ? true
        : v === 'off'
        ? false
        : v
    ])
  )

/**
 * Targeted normalizer that only fixes dataUsageConsent checkboxes
 * Preserves all other form data unchanged
 */
export const normalizeDataConsentValues = (data) => {
  if (!data || !data.dataUsageConsent) return data

  return {
    ...data,
    dataUsageConsent: normalizeCheckboxValues(data.dataUsageConsent)
  }
}
